/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ClearSessionLockdownDataParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('not-set')],
]);
export class ClearSessionLockdownData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ClearSessionLockdownDataParser.decode(input).map(res => new ClearSessionLockdownData(res));
    }
    static unsafeDecode(input) {
        return ClearSessionLockdownData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ClearSessionLockdownDataParser.encode(data);
    }
    static schema() {
        return ClearSessionLockdownDataParser.schema();
    }
}
